/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Immature_OptimalInputs */

const en_coach_immature_optimal = /** @type {(inputs: Coach_Immature_OptimalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your fitness metrics are still stabilizing (less than 4 weeks of data). Early signs suggest a solid training load. Stay consistent and monitor how you feel — the metrics will become more meaningful soon.`)
};

const de_coach_immature_optimal = /** @type {(inputs: Coach_Immature_OptimalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Werte pendeln sich noch ein — weniger als 4 Wochen Daten. Sieht nach einem soliden Umfang aus. Bleib dran und hör auf deinen Körper — bald werden die Metriken aussagekräftiger.`)
};

/**
* | output |
* | --- |
* | "Your fitness metrics are still stabilizing (less than 4 weeks of data). Early signs suggest a solid training load. Stay consistent and monitor how you feel —..." |
*
* @param {Coach_Immature_OptimalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_immature_optimal = /** @type {((inputs?: Coach_Immature_OptimalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Immature_OptimalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_immature_optimal(inputs)
	return de_coach_immature_optimal(inputs)
});